// Canonical literals behind the subscription_history audit rows, shared by the
// `pgEnum(...)`s in `@listening/db` and the `Schema.Literals(...)` in
// `admin-endpoints.ts`, so the Postgres enums and the wire contract stay in
// lockstep from one source.
//
// They live here, not in `@listening/db`, because this package is bundled into
// the browser and `@listening/db` is server-only: importing anything from its
// schema module drags every `pgTable(...)` call — and drizzle-orm with it —
// into the public web bundle, since those calls run at module scope and survive
// tree-shaking. The dependency points server → contract, which is only possible
// because this package declares no workspace server dependency at all — what
// `scripts/lint/package-boundaries-check.ts` enforces.
export const SUBSCRIPTION_HISTORY_PROVIDERS = [
  'stripe',
  'revenue_cat',
  'referral',
  'system',
] as const;

// 'webhook' = provider webhook, 'sync' = self-healing read, 'signup' = initial
// billing row, 'manual' = admin/internal, 'checkout_intent' = a recovery point
// written by POST /billing/subscribe either side of its Stripe calls. The last
// one records no state change at all: an intent row with no matching `finished`
// row and no subscription is a started-and-lost checkout, which is a queryable
// predicate over this append-only table and has no time bound — unlike Stripe's
// idempotency keys, which expire after ~24h.
export const SUBSCRIPTION_HISTORY_EVENT_SOURCES = [
  'webhook',
  'sync',
  'signup',
  'manual',
  'checkout_intent',
] as const;
